export const abi = [
	{
		"inputs": [
			{
				"internalType": "int256",
				"name": "num1",
				"type": "int256"
			},
			{
				"internalType": "int256",
				"name": "num2",
				"type": "int256"
			}
		],
		"name": "add",
		"outputs": [
			{
				"internalType": "int256",
				"name": "",
				"type": "int256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "int256",
				"name": "num1",
				"type": "int256"
			},
			{
				"internalType": "int256",
				"name": "num2",
				"type": "int256"
			}
		],
		"name": "divide",
		"outputs": [
			{
				"internalType": "int256",
				"name": "",
				"type": "int256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "int256",
				"name": "num1",
				"type": "int256"
			},
			{
				"internalType": "int256",
				"name": "num2",
				"type": "int256"
			}
		],
		"name": "mul",
		"outputs": [
			{
				"internalType": "int256",
				"name": "",
				"type": "int256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "int256",
				"name": "num1",
				"type": "int256"
			},
			{
				"internalType": "int256",
				"name": "num2",
				"type": "int256"
			}
		],
		"name": "subtract",
		"outputs": [
			{
				"internalType": "int256",
				"name": "",
				"type": "int256"
			}
		],
		"stateMutability": "pure",
		"type": "function"
	}
];

export const contractAddress = "0x63341e437151a62519c2049d2ecbd9f7655acc11";
